import { AnalysisUserType } from "@models/platform-analysis/entities/analysis";
import { PDFPageHandlerProps } from "@models/platform-analysis/entities/steps/summary";
import { AnalysisSummarySectionId } from "@models/platform-analysis/enums/summary/sectionId";
import { Font } from "@react-pdf/renderer";
import { AnalysisSummaryStepSectionRenderConfigs } from "../../configs";
import {
  adviserInformationPageHandler,
  businessMetricsPageHandler,
  chunkSubstr,
  concludingRemarksPageHandler,
  disclaimersPageHandler,
  featurePageHandler,
  feesAnalysisPageHandler,
  objectivesPageHandler,
  platformIncludedPageHandler,
  platformSpecificCommentsPageHandler,
  portfolioDetailPageHandler,
  portfolioCompositionPageHandler,
  supplierInformationPageHandler,
  whatsIncludedPageHandler,
  smaPortfolioPageHandler,
  featureIncludedPageHandler,
  platformCommentPageHandler,
  appendixPageHandler,
  appendixFeaturePageHandler,
  appendixBusinessMetricPageHandler,
  portfolioCompositionByPlatformPageHandler,
} from "./utils";

// Local images imports
import DefaultProductLogo from "@assets/images/logo/default-product-logo.png";
import ESGIcon from "@assets/images/pdf/esg.png";
import FinancialStrengthIcon from "@assets/images/pdf/financial-strength.png";
import OperationalIcon from "@assets/images/pdf/operational.png";
import FooterLogo from "@assets/images/pdf/pdf-footer-logo.png";
import HeaderLogoDark from "@assets/images/pdf/pdf-header-logo-dark.png";
import HeaderLogoLight from "@assets/images/pdf/pdf-header-logo-light.png";
import BackgroundDark from "@assets/images/pdf/pdf_background_dark.jpg";
import BackgroundLight from "@assets/images/pdf/pdf_background_light.jpg";

export const USE_PDF_LOCAL_ASSETS =
  process.env.REACT_APP_AUTH0_REDIRECT_URL?.includes(
    "local-app.suitabilityhub.com",
  );

export const PDFFeatureSectionIconPrefix = `${process.env.REACT_APP_AUTH0_REDIRECT_URL}/pdf-images/feature-section-icons/`;
export const PDFFooterLogoS3 = USE_PDF_LOCAL_ASSETS
  ? FooterLogo
  : `${process.env.REACT_APP_AUTH0_REDIRECT_URL}/pdf-images/pdf-footer-logo.png`;
export const PDFHeaderLightLogoS3 = USE_PDF_LOCAL_ASSETS
  ? HeaderLogoLight
  : `${process.env.REACT_APP_AUTH0_REDIRECT_URL}/pdf-images/pdf-header-logo-light.png`;
export const PDFHeaderDarkLogoS3 = USE_PDF_LOCAL_ASSETS
  ? HeaderLogoDark
  : `${process.env.REACT_APP_AUTH0_REDIRECT_URL}/pdf-images/pdf-header-logo-dark.png`;
export const PDFBackgroundLightS3 = USE_PDF_LOCAL_ASSETS
  ? BackgroundLight
  : `${process.env.REACT_APP_AUTH0_REDIRECT_URL}/pdf-images/pdf_background_light.jpg`;
export const PDFBackgroundDarkS3 = USE_PDF_LOCAL_ASSETS
  ? BackgroundDark
  : `${process.env.REACT_APP_AUTH0_REDIRECT_URL}/pdf-images/pdf_background_dark.jpg`;
export const PDFDefaultPlatformLogoS3 = USE_PDF_LOCAL_ASSETS
  ? DefaultProductLogo
  : `${process.env.REACT_APP_AUTH0_REDIRECT_URL}/pdf-images/default-product-logo.png`;

export const BusinessMetricIcons = USE_PDF_LOCAL_ASSETS
  ? {
      Esg: ESGIcon,
      FinancialStrength: FinancialStrengthIcon,
      Operational: OperationalIcon,
    }
  : {
      Esg: `${process.env.REACT_APP_AUTH0_REDIRECT_URL}/pdf-images/business-metric-icons/esg.png`,
      FinancialStrength: `${process.env.REACT_APP_AUTH0_REDIRECT_URL}/pdf-images/business-metric-icons/financial-strength.png`,
      Operational: `${process.env.REACT_APP_AUTH0_REDIRECT_URL}/pdf-images/business-metric-icons/operational.png`,
    };

// export const FeatureSectionIcons = {
//   ProductMenu: `${process.env.REACT_APP_AUTH0_REDIRECT_URL}/pdf-images/feature-section-icons/Product menu.png`,
//   AccountManagement: `${process.env.REACT_APP_AUTH0_REDIRECT_URL}/pdf-images/feature-section-icons/Account management.png`,
//   CashflowManagement: `${process.env.REACT_APP_AUTH0_REDIRECT_URL}/pdf-images/feature-section-icons/Cashflow management.png`,
//   ClientAccess: `${process.env.REACT_APP_AUTH0_REDIRECT_URL}/pdf-images/feature-section-icons/Client access.png`,
//   ClientReporting: `${process.env.REACT_APP_AUTH0_REDIRECT_URL}/pdf-images/feature-section-icons/Client reporting.png`,
//   PlanningCompliance: `${process.env.REACT_APP_AUTH0_REDIRECT_URL}/pdf-images/feature-section-icons/Planning and compliance.png`,
//   DecisionSupport: `${process.env.REACT_APP_AUTH0_REDIRECT_URL}/pdf-images/feature-section-icons/Decision support.png`,
//   Integration: `${process.env.REACT_APP_AUTH0_REDIRECT_URL}/pdf-images/feature-section-icons/Integration.png`,
//   PortfolioManagement: `${process.env.REACT_APP_AUTH0_REDIRECT_URL}/pdf-images/feature-section-icons/Portfolio management.png`,
//   Tracking: `${process.env.REACT_APP_AUTH0_REDIRECT_URL}/pdf-images/feature-section-icons/Tracking.png`,
//   WholeView: `${process.env.REACT_APP_AUTH0_REDIRECT_URL}/pdf-images/feature-section-icons/Whole of wealth view.png`,
// };

export const PDFFonts = USE_PDF_LOCAL_ASSETS
  ? {
      ClashDisplayBold:
        "https://fonts.cdnfonts.com/s/65008/ClashDisplayBold.woff",
      ClashDisplayRegular:
        "https://fonts.cdnfonts.com/s/65008/ClashDisplayRegular.woff",

      EpilogueRegular:
        "https://fonts.cdnfonts.com/s/46635/Epilogue-Regular.woff",
      EpilogueSemiBold:
        "https://fonts.cdnfonts.com/s/46635/Epilogue-SemiBold.woff",
      EpilogueBold: "https://fonts.cdnfonts.com/s/46635/Epilogue-SemiBold.woff",
      EpilogueItalic: "https://fonts.cdnfonts.com/s/46635/Epilogue-Italic.woff",
      EpilogueBoldItalic:
        "https://fonts.cdnfonts.com/s/46635/Epilogue-SemiBold.woff",
    }
  : {
      ClashDisplayBold: `${process.env.REACT_APP_AUTH0_REDIRECT_URL}/pdf-fonts/ClashDisplayBold.woff`,
      ClashDisplayRegular: `${process.env.REACT_APP_AUTH0_REDIRECT_URL}/pdf-fonts/ClashDisplayRegular.woff`,

      EpilogueRegular: `${process.env.REACT_APP_AUTH0_REDIRECT_URL}/pdf-fonts/Epilogue-Regular.woff`,
      EpilogueSemiBold: `${process.env.REACT_APP_AUTH0_REDIRECT_URL}/pdf-fonts/Epilogue-SemiBold.woff`,
      EpilogueBold: `${process.env.REACT_APP_AUTH0_REDIRECT_URL}/pdf-fonts/Epilogue-Bold.woff`,
      EpilogueItalic: `${process.env.REACT_APP_AUTH0_REDIRECT_URL}/pdf-fonts/Epilogue-Italic.woff`,
      EpilogueBoldItalic: `${process.env.REACT_APP_AUTH0_REDIRECT_URL}/pdf-fonts/Epilogue-BoldItalic.woff`,
    };

Font.register({
  family: "ClashDisplay",
  fonts: [
    {
      src: PDFFonts.ClashDisplayRegular,
      fontStyle: "normal",
    },
    {
      src: PDFFonts.ClashDisplayBold,
      fontWeight: "bold",
    },
  ],
});

Font.register({
  family: "Epilogue",
  fonts: [
    {
      src: PDFFonts.EpilogueRegular,
      fontStyle: "normal",
    },
    {
      src: PDFFonts.EpilogueItalic,
      fontStyle: "italic",
    },
    {
      src: PDFFonts.EpilogueSemiBold,
      fontWeight: "semibold",
    },
    {
      src: PDFFonts.EpilogueBold,
      fontWeight: "bold",
    },
    {
      src: PDFFonts.EpilogueBoldItalic,
      fontWeight: "bold",
      fontStyle: "italic",
    },
  ],
});

Font.registerHyphenationCallback((word) => {
  if (word.length > 16 && !NonTruncatableWords.includes(word)) {
    return chunkSubstr(word, 14);
  } else {
    return [word];
  }
});

export const NonTruncatableWords = [
  "www.suitabilityhub.com",
  "performance-related",
  "individuals/entities:",
];

export class PDFStyleConfigs {
  static readonly MaxPageIndexToShowMainHeader = 1;
  static readonly MaxSingleLineCharacters = 106;
  static readonly MaxAccountBalance = 99999999;

  // A4 to pixel
  static readonly PageDPI = 72;
  static readonly PageWidth = 595;
  static readonly PageHeight = 841.5;

  // Layout size
  static readonly MarginVertical = 30;
  static readonly MarginHorizontal = 40;

  static readonly Gap2XSmall = 2;
  static readonly GapXSmall = 5;
  static readonly GapYSmall = 5;
  static readonly GapSmall = 10;
  static readonly GapMedium = 20;
  static readonly GapLarge = 30;
  static readonly GapXLarge = 40;

  static readonly PageHeaderHeight = 113;
  static readonly PageHeaderHeightWithoutHeading = 35;
  static readonly PageFooterHeight = 24;
  static readonly PageFooterDoubleLinesHeight = 32;
  static readonly PageBodyHeight = 607.5;
  static readonly PageBodyHeightWithoutHeading = 685.5;
  static readonly ReviewPageHeaderHeight = 117;
  static readonly ReviewPageHeaderHeightWithoutHeading = 39;
  static readonly ReviewPageBodyHeight = 590.5;
  static readonly ReviewPageBodyHeightWithoutHeading = 668.5;

  static readonly FirstPageHeaderHeight = 140;
  static readonly FirstPageFooterHeight = 220;
  static readonly FirstPageBodyHeight = 371.5;
  static readonly ReviewFirstPageHeaderHeight = 160;
  static readonly ReviewFirstPageFooterHeight = 220;
  static readonly ReviewFirstPageBodyHeight = 351.5;

  static readonly TitleHeight = 25;
  static readonly SubTitleHeight = 45; //TILE + SUB_TITLE
  static readonly SubTitleWithoutTitleHeight = 20;

  static readonly ContentWidth = this.PageWidth - this.MarginHorizontal * 2; //515
  static readonly ContentSingleLineHeight = 15;
  static readonly TableWidth = this.PageWidth - this.MarginHorizontal * 2; //515
  static readonly TableHeight = this.PageBodyHeight - this.TitleHeight; //586.5
  static readonly TableFooterHeight = 5;
  static readonly TableOverscoreHeight = 20;
  static readonly TableExtendOverscoreHeight = 30;
  static readonly CommaAndBlankTextLength = 2;
  static readonly DefaultMaxCharsPerLine = 80;
  static readonly TableRowHeightLinesIncrement = 10;

  // Cell width
  static readonly TableCellWidth = 60.8;
  static readonly TableFirstCellWidth = 150;
  static readonly TableGroupCellWidth = 70;
  static readonly TableSubGroupCellWidth = 90;

  // Row height
  static readonly TableRowRecommendationHeight = 10;
  static readonly TableRowRecommendationDoubleHeight = 20;
  static readonly TableRowHeaderLine = 66.5;
  static readonly TableRowHeaderLineWithRecommendation =
    this.TableRowHeaderLine + this.TableRowRecommendationHeight;
  static readonly TableRowHeaderSingleLine = 25;
  static readonly TableRowHeaderDoubleLine = 69;
  static readonly TableRowHeaderDoubleLineNoLogo = 34;
  static readonly TableRowHeaderDoubleLineNoLogoWithRecommendation =
    this.TableRowHeaderDoubleLineNoLogo + this.TableRowRecommendationHeight;
  static readonly TableRowHeaderTripleLineNoLogo = 38;
  static readonly TableRowHeaderQuadrupleLineNoLogo = 48;
  static readonly TableRowHeaderQuinTupleLineNoLogo = 58;
  static readonly TableRowHeaderSextupleLineNoLogo = 70;
  static readonly TableRowSingleLine = 20;
  static readonly TableRowMultipleLine = 30;
  static readonly TableRowTripleLine = 50;
  static readonly TableRowQuadrupleLine = 80;
  static readonly TableRowMaxCharsPerLine = 48;
  static readonly TableRowMaxCharsPerLineWithHasEssential = 45;
  static readonly TableCellMaxCharsPerLine = 15;
  static readonly TableRowCommentLine = 260;
  static readonly TableRowFeatureIncludeLine = 120;

  //Comment Content Height

  static readonly CommentShortListedCellWidth = 0.221 * this.TableWidth - 7;
  static readonly AppendixCommentCellWidth = 0.19675 * this.TableWidth - 7;
  static readonly MinimumCommentCellHeight = 55;
  static readonly CommentTableHeaderHeight = 25;
  static readonly AppendixCommentTableHeaderHeight = 40;
  static readonly MarginDefault = 15;

  //Offset
  static readonly TableHeightOffset = 20;

  //Line chart
  static readonly MinHeightChart = 250;
  static readonly HeightLegendChart = 25;
  static readonly DeviationWeight = 0.485555;
  static readonly MaxValueFitContent = 1000000;
  static readonly MinimumDefaultStepStart = 10000;

  // Portfolio details
  static readonly PortfolioDetailsFirstColumnWidth = this.TableFirstCellWidth;
  static readonly PortfolioDetailsValueColSpan = 6;
  static readonly PortfolioDetailsValueColWidth =
    this.TableCellWidth * this.PortfolioDetailsValueColSpan;
  static readonly PortfolioDetailsValueColMaxChars =
    this.TableCellMaxCharsPerLine * this.PortfolioDetailsValueColSpan;
  static readonly PortfolioDetailsLabelColMaxChars =
    this.TableCellMaxCharsPerLine * 2;

  //Portfolio Composition
  static readonly CompositionMaxProductsDisplay = 5;
  static readonly CompositionFirstCellWidth = this.TableFirstCellWidth;
  static readonly CompositionFollowingCellWidth =
    (this.TableWidth - this.CompositionFirstCellWidth) /
    this.CompositionMaxProductsDisplay;
  static readonly CompositionTableHeaderHeight =
    this.TableRowHeaderDoubleLineNoLogo + 5;
  static readonly CompositionTableFooterHeight = 20;
  static readonly CompositionTableTitleHeight = 20;
  static readonly CompositionSectionGapHeight = 30;
  static readonly CompositionHiddenProductsNoteHeight = 25;
  static readonly CompositionNoDataNoteHeight = 60;
  static readonly CompositionDefaultRowHeight = 16;
  static readonly CompositionRowHeightLinesMultiplier = 7.75;
  static readonly CompositionDefaultFontSize = 7;
  static readonly CompositionRowNameFontSize = 7;
  static readonly CompositionDefaultMaxCharsPerLine = 37;
  static readonly CompositionSubTotalMaxCharsPerLine = 39;
  static readonly CompositionFixedDecimalPlaces = 2;

  //SMA Portfolio
  static readonly SMAPortfolioMaxProductsDisplay = 5;
  static readonly SMAPortfolioDefaultFontSize = 7;
  static readonly SMAPortfolioFirstCellWidth =
    this.TableFirstCellWidth + this.TableCellWidth;
  static readonly SMAPortfolioFollowingCellWidth =
    (this.TableWidth - this.SMAPortfolioFirstCellWidth) /
    this.SMAPortfolioMaxProductsDisplay;
  static readonly SMAPortfolioTableHeaderHeight =
    this.TableRowHeaderDoubleLineNoLogo + 5;
  static readonly SMAPortfolioTableFooterHeight = 20;
  static readonly SMAPortfolioTableTitleHeight = 20;
  static readonly SMAPortfolioSectionGapHeight = 30;
  static readonly SMAPortfolioDefaultRowHeight = 16;
  static readonly SMAPortfolioRowHeightLinesMultiplier = 7.25;
  static readonly SMAPortfolioDefaultMaxCharsPerLine = 30;
  static readonly SMAPortfolioDefaultMaxCharsPerLineOfValue = 11;
  static readonly SMAPortfolioNoDataSectionHeight = 85;

  //Fee Analysis
  static readonly FeeAnalysisMaxFeeDetailsColumnToDisplayLogo = 8;
  static readonly FeeAnalysisReduceFeeColumnHeight = 5;
  static readonly FeeAnalysisRowHeight = 35;
  static readonly FeeAnalysisFooterHeight = 40;
  static readonly FeeAnalysisLabelLineDetailHeight = 25;
  static readonly FeeAnalysisLabelLineProjectionHeight = 10;
  static readonly FeeAnalysisMarginHeight = 25;
  static readonly FeeAnalysisFeeDetailContentWidth = 450;
  static readonly FeeAnalysisFeeDetailContentWidthWithoutLogo = 475;
  static readonly FeeAnalysisMaxSubProductLegendPerRow = 5;
  static readonly FeeAnalysisDefaultFeeTitleHeight = 17;
  static readonly FeeAnalysisMinLightness = 15;
  static readonly FeeAnalysisMaxLightness = 90;
  static readonly FeeAnalysisAvgLightness = 70;
  static readonly FeeAnalysisDefaultHue = 242;
  static readonly FeeAnalysisDefaultSaturation = 70;
  static readonly FeeAnalysisSubProductCardHasManyFeeColumns = 65;
  static readonly FeeAnalysisSubProductCardHasNoManyFeeColumns = 130;
  static readonly FeeAnalysisSubProductCardRecommendationBadgeWidth = 3;
  static readonly FeeAnalysisLineChartMinLightness = 20;
  static readonly FeeAnalysisLineChartMaxLightness = 90;
  static readonly FeeAnalysisLineChartDefaultColorTick = 12;
  static readonly FeeAnalysisLineChartDefaultColors = [
    //#007bff
    {
      hue: 211,
      saturation: 100,
      lightness: 50,
    },
    //#6b38ca
    {
      hue: 261,
      saturation: 58,
      lightness: 51,
    },
    //#e84d1e
    {
      hue: 14,
      saturation: 81,
      lightness: 51,
    },
    //#007f58
    {
      hue: 162,
      saturation: 100,
      lightness: 25,
    },
    //#ef9116
    {
      hue: 34,
      saturation: 87,
      lightness: 51,
    },
    //#ea2787
    {
      hue: 330,
      saturation: 82,
      lightness: 54,
    },
    //#d32a2a
    {
      hue: 0,
      saturation: 67,
      lightness: 50,
    },
    //#211da2
    {
      hue: 242,
      saturation: 70,
      lightness: 37,
    },
    //#25324b
    {
      hue: 219,
      saturation: 34,
      lightness: 22,
    },
    //#e500c1
    {
      hue: 309,
      saturation: 100,
      lightness: 45,
    },
    //Repeat color
    //#007bff
    {
      hue: 211,
      saturation: 100,
      lightness: 50,
    },
    //#6b38ca
    {
      hue: 261,
      saturation: 58,
      lightness: 51,
    },
    //#e84d1e
    {
      hue: 14,
      saturation: 81,
      lightness: 51,
    },
    //#007f58
    {
      hue: 162,
      saturation: 100,
      lightness: 25,
    },
    //#ef9116
    {
      hue: 34,
      saturation: 87,
      lightness: 51,
    },
    //#ea2787
    {
      hue: 330,
      saturation: 82,
      lightness: 54,
    },
    //#d32a2a
    {
      hue: 0,
      saturation: 67,
      lightness: 50,
    },
    //#211da2
    {
      hue: 242,
      saturation: 70,
      lightness: 37,
    },
    //#25324b
    {
      hue: 219,
      saturation: 34,
      lightness: 22,
    },
    //#e500c1
    {
      hue: 309,
      saturation: 100,
      lightness: 45,
    },
    //Repeat color
    //#007bff
    {
      hue: 211,
      saturation: 100,
      lightness: 50,
    },
    //#6b38ca
    {
      hue: 261,
      saturation: 58,
      lightness: 51,
    },
    //#e84d1e
    {
      hue: 14,
      saturation: 81,
      lightness: 51,
    },
    //#007f58
    {
      hue: 162,
      saturation: 100,
      lightness: 25,
    },
    //#ef9116
    {
      hue: 34,
      saturation: 87,
      lightness: 51,
    },
    //#ea2787
    {
      hue: 330,
      saturation: 82,
      lightness: 54,
    },
    //#d32a2a
    {
      hue: 0,
      saturation: 67,
      lightness: 50,
    },
    //#211da2
    {
      hue: 242,
      saturation: 70,
      lightness: 37,
    },
    //#25324b
    {
      hue: 219,
      saturation: 34,
      lightness: 22,
    },
    //#e500c1
    {
      hue: 309,
      saturation: 100,
      lightness: 45,
    },
  ];
}

export class PDFHtmlTags {
  static readonly P = "p";
  static readonly STRONG = "strong";
  static readonly UL = "ul";
  static readonly OL = "ol";
  static readonly LI = "li";
  static readonly BR = "br";
  static readonly EM = "em";
  static readonly SPAN = "span";
  static readonly U = "u";
  static readonly I = "i";
}

export const PDFConfigsMap: Record<
  AnalysisSummarySectionId,
  {
    pageHandler: ((props: PDFPageHandlerProps) => number) | null;
    title?: { [key in AnalysisUserType]?: string };
    showFor?: AnalysisUserType[];
  } | null
> = {
  [AnalysisSummarySectionId.SupplierInformation]: {
    pageHandler: supplierInformationPageHandler,
  },
  [AnalysisSummarySectionId.AdviserInformation]: {
    pageHandler: adviserInformationPageHandler,
  },
  [AnalysisSummarySectionId.Objective]: {
    pageHandler: objectivesPageHandler,
  },
  [AnalysisSummarySectionId.WhatsIncluded]: {
    pageHandler: whatsIncludedPageHandler,
    title: {
      adviser: "What’s included in this Suitability Review",
    },
  },
  [AnalysisSummarySectionId.ProductRecommendations]: null,
  [AnalysisSummarySectionId.PlatformSelected]: null,
  [AnalysisSummarySectionId.FeatureAnalysis]: {
    pageHandler: featurePageHandler,
    title: {
      adviser: "Feature review",
      supplier: "Feature analysis",
    },
  },
  [AnalysisSummarySectionId.BusinessMetricsAnalysis]: {
    pageHandler: businessMetricsPageHandler,
    title: {
      adviser: "Business review",
      supplier: "Business metric analysis",
    },
  },
  [AnalysisSummarySectionId.PortfolioDetails]: {
    pageHandler: portfolioDetailPageHandler,
  },
  [AnalysisSummarySectionId.PortfolioComposition]: {
    pageHandler: portfolioCompositionPageHandler,
  },
  [AnalysisSummarySectionId.FeeEstimates]: {
    pageHandler: feesAnalysisPageHandler,
    title: {
      supplier: "Fee analysis",
      adviser: "Fee review",
    },
  },
  [AnalysisSummarySectionId.SmaPortfolioFees]: {
    pageHandler: smaPortfolioPageHandler,
    title: {
      supplier: "Fee analysis",
      adviser: "Fee review",
    },
  },
  [AnalysisSummarySectionId.ConcludingRemarks]: {
    pageHandler: concludingRemarksPageHandler,
  },
  [AnalysisSummarySectionId.PlatformComments]: {
    pageHandler: platformCommentPageHandler,
  },
  [AnalysisSummarySectionId.PlatformSpecificComments]: {
    pageHandler: platformSpecificCommentsPageHandler,
  },
  [AnalysisSummarySectionId.PlatformIncluded]: {
    pageHandler: platformIncludedPageHandler,
  },
  [AnalysisSummarySectionId.FeatureIncluded]: {
    pageHandler: featureIncludedPageHandler,
  },
  [AnalysisSummarySectionId.Appendix]: {
    pageHandler: appendixPageHandler,
  },
  [AnalysisSummarySectionId.AppendixPlatformComments]: {
    pageHandler: platformCommentPageHandler,
  },
  [AnalysisSummarySectionId.AppendixFeatureAnalysis]: {
    pageHandler: appendixFeaturePageHandler,
    title: {
      supplier: "Feature analysis",
      adviser: "Feature review",
    },
  },
  [AnalysisSummarySectionId.AppendixBusinessMetricAnalysis]: {
    pageHandler: appendixBusinessMetricPageHandler,
    title: {
      adviser: "Business metric review",
    },
  },
  [AnalysisSummarySectionId.AppendixPortfolioComposition]: {
    pageHandler: portfolioCompositionByPlatformPageHandler,
  },
  [AnalysisSummarySectionId.AppendixFeeEstimateAnalysis]: {
    pageHandler: feesAnalysisPageHandler,
    title: {
      adviser: "Fee review",
    },
  },
  [AnalysisSummarySectionId.AppendixSmaPortfolioFees]: {
    pageHandler: smaPortfolioPageHandler,
    title: {
      supplier: "Fee analysis",
      adviser: "Fee review",
    },
  },
  [AnalysisSummarySectionId.Disclaimers]: {
    pageHandler: disclaimersPageHandler,
    title: { adviser: "Disclaimers", supplier: "Disclaimers" },
    showFor: ["adviser", "supplier"],
  },
};

export const PDFSectionRenderConfigs = Object.keys(PDFConfigsMap)
  .map((configKey) => {
    const config = PDFConfigsMap[configKey as AnalysisSummarySectionId];
    const renderConfig = AnalysisSummaryStepSectionRenderConfigs.find(
      (section) => section.id === configKey,
    );

    if (renderConfig) {
      return {
        ...renderConfig,
        pdfPageHandler: config ? config.pageHandler : undefined,
        pdfTitle: config ? config.title : undefined,
      };
    }

    return null;
  })
  .concat([
    {
      id: AnalysisSummarySectionId.Disclaimers,
      name: { adviser: "Disclaimers", supplier: "Disclaimers" },
      showFor: ["adviser", "supplier"],
      Component: null,
      pdfPageHandler:
        PDFConfigsMap[AnalysisSummarySectionId.Disclaimers]?.pageHandler,
      pdfTitle: PDFConfigsMap[AnalysisSummarySectionId.Disclaimers]?.title,
    },
  ]);
